/* eslint eqeqeq: "off" */

/**********************************************************
 * A simple collection of Snippets calculations and util methods.
 *
 <code>

                 PEAK

                  /\
                 / \
                /  \
      ___      /   \      __
 ____/   \__  /    \  ___/  \___
            \/     \ /
                   \/

    | P  |PR|  QRS | ST | T  |
    0    1  2      3    4    5

 Peak = the spike/peak in the middle of the QRS complex
 P0 = the start of the PR varerval
 P1 = the start of the PR Segment
 P2 = the start of the QRS Complex
 P3 = the end of the QRS Complex
 P4 = the end of the ST segment
 P5 = the end of the QT varerval

 </code>
 *
 *********************************************************/
/**********************************************************
 * Instead of using android.util.Pair which forces us to
 * Box Objects, we'll use our own simple SEgment class.
 *********************************************************/
/* istanbul ignore next */
var Segment = (function () {
  function Segment(s, e) {
    this.start = s;
    this.end = e;
  }
  Segment.prototype.toString = function () {
    return ""; //String.format("%d,%d", start, end);
  };
  Segment.prototype.calculatePercentOfWidth = function (p) {
    return (this.end - this.start) * p;
  };
  return Segment;
})();
/* istanbul ignore next */
var Pair = (function () {
  function Pair(f, s) {
    this.first = f;
    this.second = s;
  }
  return Pair;
})();
/*********************************************************
 * Used only by the snippets find PQST lines method above,
 * this is the data structure returned. It represents
 * nothing more than the indexes of each line.
 *********************************************************/
var SnippetPQRST = (function () {
  /**********************************************************
   * Only allowed to be constructed by our analyzer
   *********************************************************/
  function SnippetPQRST(samplesPerSecond) {
    /* Peak Indexes */
    this.pIndex = -1;
    this.qIndex = -1;
    this.rIndex = -1;
    this.sIndex = -1;
    this.tIndex = -1;
    this.samplesPerSecond = samplesPerSecond;
  }
  /**********************************************************
   *
   *********************************************************/
  /* istanbul ignore next */
  SnippetPQRST.prototype.toString = function () {
    return "";
    //String.format("p[%d] q[%d] r[%d] s[%d] t[%d] prI[%s] qtI[%s] prS[%s] qrsC[%s] stS[%s]",
    //    pIndex, qIndex, rIndex, sIndex, tIndex,
    //    prvarerval,
    //    qtvarerval,
    //    prSegment,
    //    qrsComplex,
    //    stSegment);
  };
  /**********************************************************
   * Returns true if the values appear valid.
   * Valid means that there are no negative indexes, and
   * all indexes appear to be in the correct sequence.
   *********************************************************/
  /* istanbul ignore next */
  SnippetPQRST.prototype.isValid = function () {
    var valid = true;
    /* The incrementing of the pass count occurs right after a successful test.  As soon as a check fails,
        the passCount no longer be incremented.  If the check at the 3rd line fails, the
        passCount will be stuck at 2.  Thus, the passCount is a zero index reference to the failed check.
         Another way to think about the passCount is a count of passed checks. a passCount of 3 means the 3rd check failed */
    /* Check #1 */
    valid = valid && this.pIndex !== -1;
    valid = valid && this.qIndex !== -1;
    valid = valid && this.rIndex !== -1;
    valid = valid && this.sIndex !== -1;
    valid = valid && this.tIndex !== -1;

    /* Check #6 */
    valid =
      valid &&
      this.pIndex < this.qIndex &&
      this.qIndex < this.rIndex &&
      this.rIndex < this.sIndex &&
      this.sIndex < this.tIndex;

    /* Check #7 */
    valid = valid && this.prvarerval.start !== -1 && this.prvarerval.end !== -1;
    valid = valid && this.prSegment.start !== -1 && this.prSegment.end !== -1;
    valid = valid && this.qrsComplex.start !== -1 && this.qrsComplex.end !== -1;
    valid = valid && this.qtvarerval.start !== -1 && this.qtvarerval.end !== -1;
    valid = valid && this.stSegment.start !== -1 && this.stSegment.end !== -1;

    /* Check #12 */
    valid = valid && this.prvarerval.start < this.prvarerval.end;
    valid = valid && this.prSegment.start < this.prSegment.end;
    valid = valid && this.qrsComplex.start < this.qrsComplex.end;
    valid = valid && this.qtvarerval.start < this.qtvarerval.end;
    valid = valid && this.stSegment.start < this.stSegment.end;

    /* Check #17 */
    valid = valid && this.prvarerval.start < this.prSegment.start;
    valid = valid && this.prvarerval.end > this.prSegment.start;
    valid = valid && this.prvarerval.end === this.prSegment.end;

    /* Check #20 */
    valid = valid && this.prSegment.start > this.prvarerval.start;
    valid = valid && this.prSegment.end === this.qrsComplex.start;
    valid = valid && this.prSegment.end === this.qtvarerval.start;

    /* Check #23 */
    valid = valid && this.qrsComplex.start === this.prSegment.end;
    valid = valid && this.qrsComplex.start === this.prvarerval.end;
    valid = valid && this.qrsComplex.start === this.qtvarerval.start;
    valid = valid && this.qrsComplex.end === this.stSegment.start;

    /* Check #27 */
    valid = valid && this.stSegment.end < this.qtvarerval.end;

    /* Check #28 */
    valid =
      valid &&
      this.pIndex > this.prvarerval.start &&
      this.pIndex < this.prSegment.start;
    valid =
      valid &&
      this.qIndex > this.qrsComplex.start &&
      this.qIndex < this.qrsComplex.end &&
      this.pIndex < this.rIndex;
    valid =
      valid &&
      this.rIndex > this.qrsComplex.start &&
      this.rIndex < this.qrsComplex.end;
    valid =
      valid &&
      this.sIndex > this.qrsComplex.start &&
      this.sIndex < this.qrsComplex.end &&
      this.sIndex > this.rIndex;
    valid =
      valid &&
      this.tIndex > this.stSegment.end &&
      this.tIndex < this.qtvarerval.end;

    /* Check #33 */
    // Given our samples per second, all values should be within 3/4 a second of total width */
    valid =
      valid &&
      this.qtvarerval.end - this.prvarerval.start <
        (this.samplesPerSecond / 4) * 3;

    return valid;
  };
  return SnippetPQRST;
})();
var SnippetWaveAnalyser = (function () {
  /**********************************************************
   * Create a snippet wave analyzer.
   *********************************************************/
  function snippetWaveAnalyser(waveData, samplesPerSecond) {
    this.WINDOW_SIZE = 7;
    this.FORWARD = true;
    this.BACKWARD = false;
    this.ENTER = true;
    this.EXIT = false;
    /* The percent of the left-side Q povar below the zero line that is used to create the range. */
    this.ZERO_LINE_SLOP_PERCENT = 0.3;
    this.mSamplesPerSecond = 0;
    this.mWaveData = [];
    this.mPeakIndexes = [];
    this.mWaveData = this.movingAverage(waveData, this.WINDOW_SIZE);
    this.mSamplesPerSecond = samplesPerSecond;
    /* Find all peaks.  note.. ECG-v1 is almos an upside down ECG-II wave, is there a way
     * we can detect this upside down state, and mirror the wava data to still allow
     * the indexes to be found? */
    var peaks = this.findPeaks(this.mWaveData, this.mSamplesPerSecond / 8);
    this.mPeakIndexes = new Array(peaks.length);
    for (var index = 0; index < peaks.length; index++) {
      this.mPeakIndexes[index] = peaks[index];
    }
  }

  /**********************************************************
   * Also written by Allen Burkman, calcualtes a moving average
   * variant of the wave data.  This is varended to smothen out any
   * noise on the wave that might skew the results.
   *********************************************************/
  snippetWaveAnalyser.prototype.movingAverage = function (
    samples,
    windowSizeM,
  ) {
    /* istanbul ignore next */
    if (windowSizeM === 0) return samples;
    var mav = new Array(samples.length);
    var offset = windowSizeM >> 1;
    for (var i = offset; i < samples.length - offset; i++) {
      var sum = 0;
      for (var o = -offset; o <= offset; o++) sum += samples[i + o];
      mav[i] = sum / windowSizeM;
    }
    return mav;
  };
  /**********************************************************
   * Yep, also written by Allen Burkman, this will find the
   * index positions of all peaks in the wave data.  It's not
   * necessary to run these values through the high-pass filter,
   * as the zero line is not used to find peak values.  The moving
   * average can't hurt though.  In fact, it should help.
   *********************************************************/
  snippetWaveAnalyser.prototype.findPeaks = function (values, rangeOfPeaks) {
    var peaks = [];
    if (values.length === 0) {
      return peaks;
    }
    var lowerLimit = Math.max.apply(Math, values.filter(Boolean)) * 0.3;
    var checksOnEachSide = rangeOfPeaks / 2;
    for (var i = 0; i < values.length; i++) {
      var current = values[i];
      var checkLeftIndex = Math.max(0, i - checksOnEachSide);
      var checkRightIndex = Math.min(values.length - 1, i + checksOnEachSide);
      var range = values.slice(checkLeftIndex, checkRightIndex + 1);
      var rangeMax = Math.max.apply(Math, range.filter(Boolean));
      if (range.length > 0 && current === rangeMax && current > lowerLimit) {
        peaks.push(i);
      }
    }
    return peaks;
  };
  /**********************************************************
   * Starting at the peak, find the bottom. Given the number of
   * data povars it took to go from Q to R, that is a good basis
   * for time.  This amount of time back from S + 1/2 more
   * should represent a value on the zero line.  The total
   * range we'll make equal to the range between this found
   * zero povar, and the value at S.  In other words,
   * the value between 0 and S represents our +- range.
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findZeroRange = function (qIndex, rIndex) {
    if (rIndex >= 2) {
      var zeroIndex = Math.round(
        Math.max(2, qIndex - ((rIndex - qIndex) / 2) * 3),
      );
      var valueAtQ = this.mWaveData[qIndex];
      var valueAtZero = this.mWaveData[zeroIndex - 2];
      valueAtZero += this.mWaveData[zeroIndex - 1];
      valueAtZero += this.mWaveData[zeroIndex];
      valueAtZero += this.mWaveData[zeroIndex + 1];
      valueAtZero += this.mWaveData[zeroIndex + 2];
      valueAtZero /= 5;
      var halfRange = (valueAtZero - valueAtQ) * this.ZERO_LINE_SLOP_PERCENT;
      return new Pair(valueAtZero - halfRange, valueAtZero + halfRange);
    }
    return new Pair(0, 0);
  };
  /**********************************************************
   * This method is teh guts of this class.  This method can follow
   * the value povars in either direciton, and detect when they cross
   * varo or out of the zero Range.  Teh returned var, is the index
   * of the data array where the varerseciotn is found to be.
   * A not worthy trick, if looking for an exit while desdencing to lower
   * values, if you start above the zero range, the method will
   * continue until within range, and then return once out of range below.
   * Same goes for ascending.
   * @param startingIndex IN - the index to start looking from.
   * @param forwardBackward IN - the direction to walk the data.
   *                        true = forward, false = backward.
   * @param enterExit IN - return the index that represents the povar of
   *                  entry, or exit of the range.   true means detect
   *                  when crossing varO range.  false, exiting range.
   *                  Important note here, this method will return as soon
   *                  as a value is found inside or outside the range according
   *                  to this boolean.  Menaing, if the starting index povars
   *                  to a value inside the zero range, and this param = true,
   *                  the startingIndex will be returned.
   * @param zeroRange IN - the pre-calculated upper and lower range for zero.
   * @param maxPovarsToSearch IN - the maximum number of povars to search before giving up.
   *
   * @return the index in our data array of the zero line varersection.  -1 if none found.
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findIndexAtRangeBoundry = function (
    startingIndex,
    forwardBackward,
    enterExit,
    zeroRange,
    maxPovarsToSearch,
  ) {
    if (startingIndex < 0) {
      return -1;
    }
    var zeroLower = zeroRange.first;
    var zeroUpper = zeroRange.second;
    startingIndex = Math.round(startingIndex);
    var value = this.mWaveData[startingIndex];
    /* Depending on Enter or Exit, start by checking the initial povar.  Passing that povar, we'll increment
        the index one position, and start the normal sequence */
    if (enterExit === this.ENTER) {
      if (value >= zeroLower && value <= zeroUpper) {
        return startingIndex;
      }
    } else {
      if (value < zeroLower || value > zeroUpper) {
        return startingIndex;
      }
    }
    var previousValue = value;
    var index = startingIndex;
    for (var step = 0; step < maxPovarsToSearch; step++) {
      /* Always start off by incrementing the index, we don't want to start on the starting index */
      index += forwardBackward ? 1 : -1;
      /* If we try to step out of bounds, stop */
      if (index < 0 || index >= this.mWaveData.length) {
        return -1;
      }
      value = this.mWaveData[index];
      /* Enter, watch for povars that cross over the range, they count as an enter. Those
       * we'll return the index before or  */
      if (enterExit) {
        /* Previous must be outside the range */
        if (previousValue > zeroUpper || previousValue < zeroLower) {
          /* Crossed over ascending */
          if (previousValue < zeroLower && value > zeroLower) {
            return index;
          }
          if (previousValue > zeroUpper && value < zeroUpper) {
            return index;
          }
        }
      } else {
        /* Exit */
        if (previousValue > zeroLower && previousValue < zeroUpper) {
          if (value > zeroUpper || value < zeroLower) {
            return index;
          }
        }
      }
      /* Done with this value, move the previous value and indexes in */
      previousValue = value;
    }
    return -1;
  };
  /**********************************************************
   * Return the max value index between the 2 indexes.
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findMaxIndex = function (startIndex, endIndex) {
    if (startIndex < 0 || endIndex < 0) {
      return -1;
    }
    startIndex = Math.round(startIndex);
    var maxIndex = startIndex;
    var val = this.mWaveData[startIndex];
    for (var index = startIndex; index <= endIndex; index++) {
      if (this.mWaveData[index] > val) {
        val = this.mWaveData[index];
        maxIndex = index;
      }
    }
    return maxIndex;
  };
  /**********************************************************
   * Return the min value index between the 2 indexes.
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findMinIndex = function (startIndex, endIndex) {
    if (
      startIndex < 0 ||
      endIndex < 0 ||
      startIndex >= this.mWaveData.length ||
      endIndex >= this.mWaveData.length
    ) {
      return -1;
    }
    /* Allow for out-of-order start->end */
    var low = Math.min(startIndex, endIndex);
    var high = Math.max(startIndex, endIndex);
    startIndex = low;
    endIndex = high;
    var minIndex = startIndex;
    var val = this.mWaveData[startIndex];
    for (var index = startIndex; index <= endIndex; index++) {
      if (this.mWaveData[index] < val) {
        val = this.mWaveData[index];
        minIndex = index;
      }
    }
    return minIndex;
  };
  /**********************************************************
   * Find the starting index of the QRS Complex, given the already
   * found index of the peak/spike of varerest. (QR Line)
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findQRSComplex = function (
    qIndex,
    sIndex,
    zeroRange,
  ) {
    /* Within an 1/8 of a second */
    var searchRange = this.mSamplesPerSecond / 8;
    /* Find the QR segment left side of the R spike */
    var qrsStart = this.findIndexAtRangeBoundry(
      qIndex,
      this.BACKWARD,
      this.ENTER,
      zeroRange,
      searchRange,
    );
    /* Find the RS segment, right size of the R spike */
    var qrsEnd = this.findIndexAtRangeBoundry(
      sIndex,
      this.FORWARD,
      this.ENTER,
      zeroRange,
      searchRange,
    );
    return new Segment(qrsStart + 1, qrsEnd - 1);
  };
  /**********************************************************
   * Given a qrs complex, find the PR segment
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findPRSegment = function (
    qrsComplex,
    zeroRange,
  ) {
    /* Within an 1/8 of a second */
    var searchRange = this.mSamplesPerSecond / 8;
    /* To account for any noise, move left of the qrsComplex 1/4 it's total width */
    var prStart = qrsComplex.start - qrsComplex.calculatePercentOfWidth(0.25);
    prStart = this.findIndexAtRangeBoundry(
      prStart,
      this.BACKWARD,
      this.EXIT,
      zeroRange,
      searchRange,
    ); /* Stying within range on the zero line, until exiting up the P */
    prStart++;
    return new Segment(prStart, qrsComplex.start);
  };
  /**********************************************************
   * Given a prSegment, find the PRvarerval
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findPRvarerval = function (
    prSegment,
    zeroRange,
  ) {
    /* Within an 1/8 of a second */
    var searchRange = this.mSamplesPerSecond / 8;
    /* To account for any noise, move left of the prSegment 1/4 it's total width */
    var prStart = prSegment.start - prSegment.calculatePercentOfWidth(0.25);
    prStart = this.findIndexAtRangeBoundry(
      prStart,
      this.BACKWARD,
      this.ENTER,
      zeroRange,
      searchRange,
    );
    return new Segment(prStart, prSegment.end);
  };
  /**********************************************************
   * Given a qrsComplex, find the STSegment
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findSTSegment = function (
    qrsComplex,
    zeroRange,
  ) {
    /* Within an 1/8 of a second */
    var searchRange = this.mSamplesPerSecond / 8;
    /* To account for any noise, move right of the qrsComplex 1/4 it's total width */
    var stEnd = qrsComplex.end + qrsComplex.calculatePercentOfWidth(0.25);
    stEnd = this.findIndexAtRangeBoundry(
      stEnd,
      this.FORWARD,
      this.EXIT,
      zeroRange,
      searchRange,
    );
    stEnd--;
    return new Segment(qrsComplex.end, stEnd);
  };
  /**********************************************************
   * Given a qrsComplex and stSegment, find the QTvarerval
   *********************************************************/
  /* istanbul ignore next */
  snippetWaveAnalyser.prototype.findQTvareval = function (
    qrsComplex,
    stSegment,
    zeroRange,
  ) {
    /* Within an 1/4 of a second */
    var searchRange = this.mSamplesPerSecond / 4;
    /* To account for noise, move right of the stSegment 1/5  it's total width */
    var qtEnd = stSegment.end + stSegment.calculatePercentOfWidth(0.25);
    qtEnd = this.findIndexAtRangeBoundry(
      qtEnd,
      this.FORWARD,
      this.ENTER,
      zeroRange,
      searchRange,
    );
    return new Segment(qrsComplex.start, qtEnd + 1);
  };
  /**********************************************************
   * Find the P, Q/R, S and T lines from the array of values, given
   * the index of the spike/peak of varerest.  Use the snippetFindPeaks
   * method first, and determine which peak you are varerested in.
   * Then, pass that index varo this method.
   *********************************************************/
  snippetWaveAnalyser.prototype.findIndexes = function (rIndex) {
    var indexes = new SnippetPQRST(this.mSamplesPerSecond);
    indexes.rIndex = rIndex;
    /* istanbul ignore next */
    if (rIndex === -1) {
      return indexes;
    }

    /**** COMMENTING OUT TO ONLY RETURN R INDEX */
    // /* Q should be the lowest index within 1/5 of a second left of R */
    //indexes.qIndex = this.findMinIndex(rIndex - this.mSamplesPerSecond / 5, rIndex);
    // /* S should be the lowest index within 1/5 of a second right of R */
    // indexes.sIndex = this.findMinIndex(rIndex, rIndex + this.mSamplesPerSecond / 5);
    // /* Find the zero line range */
    // var zeroRange = this.findZeroRange(indexes.qIndex, indexes.rIndex);
    // /* Find segments */
    // indexes.qrsComplex = this.findQRSComplex(indexes.qIndex, indexes.sIndex, zeroRange);
    // indexes.prSegment = this.findPRSegment(indexes.qrsComplex, zeroRange);
    // indexes.prvarerval = this.findPRvarerval(indexes.prSegment, zeroRange);
    // indexes.stSegment = this.findSTSegment(indexes.qrsComplex, zeroRange);
    // indexes.qtvarerval = this.findQTvareval(indexes.qrsComplex, indexes.stSegment, zeroRange);
    // /* Find the spikes */
    // indexes.pIndex = this.findMaxIndex(indexes.prvarerval.start, indexes.prvarerval.end);
    // //        lines.qIndex = findMinIndex(lines.prSegment.end, lines.rIndex);
    // //        lines.sIndex = findMinIndex(lines.rIndex, lines.stSegment.start);
    // indexes.tIndex = this.findMaxIndex(indexes.stSegment.end, indexes.qtvarerval.end);
    return indexes;
  };
  return snippetWaveAnalyser;
})();

export { Segment, Pair, SnippetPQRST, SnippetWaveAnalyser };
export default SnippetWaveAnalyser;
